<template>
  <div class="rightBar" id="rightBar">
    <div class="top autoLeft" @mouseleave="fixedNavLeave()">
      <div
        v-for="(item, key) in btnList"
        :key="key"
        :class="{
          [item.class]: true,
          'top-public': true,
          checkType: active === key || false,
        }"
        @click="fixedNavClick(item,key)"
        @mouseenter="fixedNavEnter(key)"
      >
        <a target="_blank">
          <span
            :class="{
              ccuifont: true,
              [item.iconClass]: true,
            }"
          >
            <!-- <i id="ci-count" class="ci-count" v-show="key === 0">{{
              cartNum
            }}</i>  --> </span
          >{{ item.name }}
          <span class="top-public-line" v-show="key !== 3"></span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
// 组件

const emcURL = process.env.VUE_APP_EMC_URL;
import { getUserInfo } from "@/api/login.js";

export default {
  components: {},
  props: {
    btnList: {
      type: Array,
      default: () => [
        {
          name: "客服",
          class: "ccuifont",
          iconClass: "icon-ccui-kefu",
        },
      ],
    },
  },
  data() {
    return {
      // 选中哪一个右侧列表
      rightNav: [
        // {
        //   name: "购物车",
        //   class: "shop-car",
        //   iconClass: "icon-ccui-cart-o",
        //   active: "checkType"
        // },
        // {
        //   name: "关注",
        //   class: "follow",
        //   iconClass: "icon-ccui-guanzhu"
        // },
        // {
        //   name: "反馈",
        //   class: "customer",
        //   iconClass: "icon-ccui-fankui"
        // },
        // {
        //   name: "顶部",
        //   class: "to-top",
        //   iconClass: "icon-ccui-next",
        // },
      ],
      active: 0,
      overCeart: true,
      emcURL: this.$addUrlPerFix(emcURL),
      userInfoCode: "",
    };
  },

  mounted() {
    // this.getUserInfor();
  },
  methods: {
    // 获取用户信息
    getUserInfor() {
      getUserInfo({}).then((res) => {
        this.userInfoCode = res.data.code;
      });
    },
    drop(target) {
      this.$refs.ball.drop(target);
    },
    // 侧边导航
    fixedNavClick(item,idx) {
      this.active = idx;

      if (item.class == 'ccuifont') {
        // 获取顶部导航的在线客服然后点击
        const zx = document.querySelector(".app-item.zaixian")
        zx&&zx.click()

        // window.open("https://work.weixin.qq.com/kfid/kfc49a3b7718bfad23d");
        // window.location.href = this.emcURL;
      } else if (idx === 0) {
        // if (this.userInfoCode === "111") {
        //   window.location.href =
        //     this.$addUrlPerFix(process.env.VUE_APP_LOGIN_URL) +
        //     encodeURIComponent(window.location.href);
        // } else {
        //   window.open("https://work.weixin.qq.com/kfid/kfc49a3b7718bfad23d");
        // }
      } else if (item.class == 'to-top') {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
    },
    fixedNavEnter(idx) {
      this.active = idx;
    },
    fixedNavLeave() {
      this.active = 0;
    },
  },
};
</script>

<style scoped lang="scss">
.rightBar {
  .top {
    position: fixed;
    left: 50%;
    top: 64%;
    margin-left: 610px;
    width: 61px;
    // height: 310px;
    background: #ffffff;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.09);
    z-index: 999;
    cursor: pointer;
  }

  .top .ccuifont {
    display: block;
    font-size: 17px;
    line-height: 24.25px;
    margin: 0 auto;
  }

  .top .top-public {
    cursor: pointer;
    width: 61px;
    height: 62px;
    margin: 0 auto;
    font-size: 13px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #4a4a4a;
    text-align: center;
    position: relative;
  }

  .top .top-public .top-public-line {
    position: absolute;
    bottom: -1px;
    left: 20%;
    display: block;
    width: 39px;
    height: 1px;
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 1) 0%,
      rgba(227, 227, 227, 1) 51%,
      rgba(255, 255, 255, 1) 100%
    );
  }
  .top .top-public .top-public-line:last-child {
    border-bottom: none;
  }

  .top .top-public .ccuifont {
    padding-top: 11px;
  }

  .top .top-public:hover {
    background: #ff142f;
    color: #ffffff;
  }

  .top .top-public:hover .ccuifont {
    color: #fff;
  }

  .top .top-public a {
    color: #4a4a4a;
  }

  .top .top-public:hover a {
    color: #fff;
  }

  .top .top-public .ccuifont .ci-count {
    position: absolute;
    height: 10px;
    top: 10px;
    left: 31px;
    right: auto;
    display: inline-block;
    padding: 1px 3px;
    font-size: 12px;
    line-height: 12px;
    color: #fff;
    background-color: #e1251b;
    border-radius: 7px;
    min-width: 10px;
    text-align: center;
    font-style: normal;
  }

  .top .top-public:hover .ccuifont .ci-count {
    background-color: #fff;
    color: #e1251b;
  }

  .top .checkType {
    background: #ff142f;
    color: #ffffff;
  }

  .top .checkType a {
    color: #ffffff;
  }

  .top .checkType a .ccuifont .ci-count {
    background-color: #fff;
    color: #e1251b;
  }

  .top .to-top {
    color: #e1251b;
  }

  .top .icon-ccui-next {
    transform: rotate(270deg);
    -ms-transform: rotate(270deg);
    /* IE 9 */
    -moz-transform: rotate(270deg);
    /* Firefox */
    -webkit-transform: rotate(270deg);
    /* Safari 和 Chrome */
    -o-transform: rotate(270deg);
    /* Opera */
    padding-top: 0 !important;
    padding-right: 11px !important;
    margin-bottom: 9px !important;
  }
  .balls {
    position: relative;
    top: -200px;
  }

  @media screen and (max-width: 1380px) {
    .autoLeft {
      left: auto;
      right: 10px;
      z-index: 999;
    }
  }
}
</style>
